<template>
  <page>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-toolbar dense color="grey lighten-3" flat>
              <v-btn text icon color="green">
                <v-icon @click="doPrev">mdi-keyboard-backspace</v-icon>
              </v-btn>
              <v-icon>mdi-magnify</v-icon>
              <v-toolbar-title>{{ accountsLabel.transactionsDetails }}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn class="mr-2" color="primary" @click="showGLDialog = true" :disabled="disableGLList">
                GL List
                <v-icon right>mdi-view-list</v-icon>
              </v-btn>
              <v-btn class="mr-2" color="primary" @click="showMatchDialog = true">
                Match List
                <v-icon right>mdi-view-list</v-icon>
              </v-btn>
              <v-btn color="primary" @click="showCommPVDialog = true">
                Commission Voucher
                <v-icon right>mdi-cash-multiple</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <form data-vv-scope="accountsDetailsForm">
                <v-container fluid grid-list-lg>
                  <message :messages="messages"></message>
                  <v-layout row wrap>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ accountsLabel.branch }}</v-subheader>
                      <div class="queryValue" v-for="item in filterBranchList" :key="item.label">{{ item.label }}</div>
                    </v-flex>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ accounts.documentNoLbl }}</v-subheader>
                      <span class="queryValue">{{ accounts.documentNo }}</span>
                    </v-flex>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ accountsLabel.transactionDate }}</v-subheader>
                      <span class="queryValue">{{ accounts.transactionDate }}</span>
                    </v-flex>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ accountsLabel.posted }}</v-subheader>
                      <span class="queryValue">{{ accounts.posted }}</span>
                    </v-flex>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ accountsLabel.accountNo }}</v-subheader>
                      <div class="queryValue" v-for="item in filterAccountNoList" :key="item.label">{{ item.label }}</div>
                    </v-flex>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ accountsLabel.fundSuffix }}</v-subheader>
                      <span class="queryValue">{{ filterFundSuffixList }}</span>
                    </v-flex>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ accountsLabel.department }}</v-subheader>
                      <div class="queryValue" v-for="item in filterDepartmentList" :key="item.label">{{ item.label }}</div>
                    </v-flex>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ accountsLabel.transactionGroup }}</v-subheader>
                      <span class="queryValue">{{ accounts.transactionGroup }}</span>
                    </v-flex>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ accountsLabel.gstRegistrationNo }}</v-subheader>
                      <span class="queryValue">{{ accounts.gstRegistrationNo }}</span>
                    </v-flex>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ accountsLabel.gstIOStatusRate }}</v-subheader>
                       <span class="queryValue">{{ filterGstIOStatusRate }}</span>
                    </v-flex>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ accountsLabel.currency }}</v-subheader>
                      <div class="queryValue" v-for="item in filterCurrList" :key="item.label">{{ item.label }}</div>
                    </v-flex>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ accountsLabel.rbcTran }}</v-subheader>
                      <span class="queryValue">{{ accounts.rbcTran }}</span>
                    </v-flex>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ accountsLabel.netAmount }}</v-subheader>
                      <span class="queryValue">{{ accounts.netAmount }}</span>
                    </v-flex>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ accountsLabel.localNetAmount }}</v-subheader>
                      <span class="queryValue">{{ accounts.locAmtAe }} {{ accounts.localNetAmount }}</span>
                    </v-flex>
                    <v-flex md2 xs10>
                      <v-subheader class="queryLabel">{{ accountsLabel.outstandingBalance }}</v-subheader>
                      <span class="queryValue">{{ accounts.outstandingBalance }}</span>
                    </v-flex>
                    <v-flex md2 xs2>
                      <v-checkbox color="primary" disabled :label="accountsLabel.zeroBal" v-model="accounts.zeroBal"></v-checkbox>
                    </v-flex>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ accountsLabel.localOutstandingBalance }}</v-subheader>
                      <span class="queryValue">{{ accounts.localOutstandingBalance }}</span>
                    </v-flex>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ accountsLabel.debitAmount }}</v-subheader>
                      <span class="queryValue">{{ accounts.debitAmount }}</span>
                    </v-flex>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ accountsLabel.debitGST }}</v-subheader>
                      <span class="queryValue">{{ accounts.debitGST }}</span>
                    </v-flex>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ accountsLabel.instalmentNo }}</v-subheader>
                      <span class="queryValue">{{ accounts.instalmentNo }}</span>
                    </v-flex>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ accountsLabel.dueDate }}</v-subheader>
                      <span class="queryValue">{{ accounts.dueDate }}</span>
                    </v-flex>
                    <v-flex md4 xs12 v-if="accounts.voidDate !== null">
                      <v-subheader class="queryLabel">{{ accountsLabel.voidDate }}</v-subheader>
                      <span class="queryRedValue">{{ accounts.voidDate }}</span>
                    </v-flex>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ accountsLabel.createdProgram }}, {{ accountsLabel.modifiedProgram }}</v-subheader>
                      <span class="queryValue">{{ appendCreatedModifiedProgram }}</span>
                    </v-flex>
                    <v-flex md4></v-flex>
                    <v-flex md4 xs12 v-if="accounts.voidReason !== null">
                      <v-subheader class="queryLabel">{{ accountsLabel.voidReason }}</v-subheader>
                      <span class="queryValue">{{ accounts.voidReason }}</span>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ accountsLabel.createdBy }}</v-subheader>
                      <span class="queryValue">{{ accounts.createdBy }}</span>
                    </v-flex>
                    <v-flex md4 xs12>
                      <v-subheader class="queryLabel">{{ accountsLabel.lastModifiedBy }}</v-subheader>
                      <span class="queryValue">{{ accounts.lastModifiedBy }}</span>
                    </v-flex>
                  </v-layout>
                </v-container>
              </form>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-settings</v-icon><span class="headerTitle">Match Details</span></div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <match-details :objData="matchedDet"></match-details>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-bank</v-icon><span class="headerTitle">Bank and GL Details</span></div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <bank-details
                      :objData="bankDet"
                      :banks="banks"
                      :currencies="currencies"
                      :paymentmethods="paymentmethods"
                      :payerbanks="payerbanks">
                    </bank-details>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-gavel</v-icon><span class="headerTitle">Policy and Claim Details</span></div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <policy-details :objData="policyDet" :policytypes="policytypes"></policy-details>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div><v-icon>mdi-file-document</v-icon><span class="headerTitle">Document and Report Details</span></div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <document-details :objData="documentDet"></document-details>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel :disabled="disableRIPanel">
              <v-expansion-panel-header>
                <div><v-icon>mdi-sync</v-icon><span class="headerTitle">RI Panel Details</span></div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-card>
                  <v-card-text>
                    <RI-details :itemsRI="riItems"></RI-details>
                  </v-card-text>
                </v-card>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-divider class="grey lighten-4"></v-divider>
        </v-flex>
        <v-card-actions>
          <v-btn :loading="submitting" color="error" dark @click.prevent="doBack">Cancel<v-icon dark right>mdi-cancel</v-icon></v-btn>
          <!--Remarked by lcd_20201204-->
          <v-btn :loading="submitting" color="primary" @click.prevent="checkVoidReason" v-if="showVoidBtn">
            Confirm Void<v-icon dark right>mdi-arrow-right-bold-box</v-icon></v-btn
          >
          <confirm v-model="showVoidConfirmation" @ok="doVoid">Are you sure you want to void this record?</confirm>
        </v-card-actions>
        <!-- </v-flex> -->
        <!-- CBO Added: Oct-05-2020 Comments -->
        <v-container fluid grid-list-lg v-if="showCommonComment">
          <v-layout row wrap>
            <v-flex lg12 xs12 order-lg1 order-xs2>
              <common-comments
                :commentRefNo="this.commentRefNo"
                :commentTranType="this.commentTranType"
                :mode="this.queryAcctMaster === true ? 'query' : ''"
              ></common-comments>
            </v-flex>
          </v-layout>
        </v-container>
        <v-container fluid grid-list-lg v-if="showVoidReason">
          <v-layout row wrap>
            <v-flex xs12>
              <form data-vv-scope="voidReasonForm">
                <v-card>
                  <v-card-text>
                    <v-text-field
                      v-model="form.voidReason"
                      :label="accountsLabel.voidReason"
                      :error-messages="errors.collect('form.voidReason')"
                      data-vv-name="form.voidReason"
                      :data-vv-as="accountsLabel.voidReason"
                      v-validate="'required|max:120'"
                    ></v-text-field>
                  </v-card-text>
                </v-card>
              </form>
            </v-flex>
          </v-layout>
        </v-container>
      </v-layout>
      <v-dialog v-model="showGLDialog" width="1080px">
        <v-container fluid grid-list-xs>
          <GL-list @close="showGLDialog = false" :itemsGL="glTranItems" :objData="glTransHdrDet"/>
        </v-container>
      </v-dialog>
      <v-dialog v-model="showMatchDialog" width="1350px">
        <v-container fluid grid-list-xs>
          <Matched-list @close="showMatchDialog = false" :objData="matchDet" :accountData="accounts"/>
        </v-container>
      </v-dialog>
      <v-dialog v-model="showCommPVDialog" width="1080px">
        <v-container fluid grid-list-xs>
          <CommPV-list  @close="showCommPVDialog = false" :itemsCommPV="commPVItems"/>
        </v-container>
      </v-dialog>
    </v-container>
    <v-flex xs12 v-if="this.acctMaster.transfer === 'matchTrans' || this.acctMaster.transfer === 'matchTransUpld' ">
      <v-btn class="mt-2" color="red" dark @click.prevent="doBack"> <v-icon dark left>mdi-exit-to-app</v-icon>Back </v-btn>
    </v-flex>
    <v-dialog v-model="promptCommentDialog" width="20%" persistent>
      <v-flex xs12>
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            Warning
            <v-spacer></v-spacer>
            <v-btn text icon @click="closeDialog">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text>
            <v-container fluid grid-list-sm>
              <v-layout row wrap>
                <v-flex xs12> Must add Comment. </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-dialog>
    <prompt-leave
      v-if="baseFromMatch && showPromptLeave"
      v-model="promptLeave"
      @exit="doMatchExit"
    ></prompt-leave>
  </page>
</template>

<script>
import routeMixin from '@/mixins/route'
import MessageMixin from '@/mixins/message'
import { accountsAjaxCalls } from '@/mixins/accounting/accountsAjaxCalls'
import BankDetails from '@/components/core/accounting/accounts/BankDetails'
import MatchDetails from '@/components/core/accounting/accounts/MatchDetails'
import PolicyDetails from '@/components/core/accounting/accounts/PolicyDetails'
import DocumentDetails from '@/components/core/accounting/accounts/DocumentDetails'
import { accountsViewMixin } from '@/mixins/accounting/accountsViewMixin'
import RIDetails from '@/components/core/accounting/accounts/RIDetails'
import GLList from '@/components/core/accounting/dialog/GLList'
import MatchedList from '@/components/core/accounting/dialog/MatchedList'
import CommPVList from '@/components/core/accounting/dialog/CommPVList'
import CommonComments from '@/components/core/accounting/CommonComments'
import { expandURI } from '@/utils/ajax'
import { INDIC_UNLOCK } from '@/store/types'
import PromptLeave from '@/components/core/accounting/match/prompt/PromptLeave.vue'
import { promptOnExitMixin } from '@/mixins/accounting/match/promptOnExitMixin'
import { recordLockMixin } from '@/mixins/common/recordLockMixin'
import { strJoin } from '@/utils/stringutil'

export default {
  data() {
    return {
      riItems: [],
      glTranItems: [],
      showGLDialog: false,
      showMatchDialog: false,
      showCommPVDialog: false,
      commPVItems: [],
      departments: [],
      currencies: [],
      gstStatuses: [],
      banks: [],
      paymentmethods: [],
      payerbanks: [],
      policytypes: [],
      allbranches: [],
      accountnos: [],
      funds: [],
      acctnosuffixes: [],
      submitting: false,
      showVoidConfirmation: false,
      promptCommentDialog: false,
      disableRIPanel: true,
      disableGLList: false,
      showVoidBtn: false,
      showVoidReason: false,
      showCommonComment: false,
      form: {
        voidReason: ''
      },
      showPromptLeave: true
    }
  },
  created() {
    if (this.fromAcctMaster === false) {
      this.showVoidBtn = true
      this.showVoidReason = true
      this.showCommonComment = false
    } else {
      this.showVoidBtn = false
      this.showVoidReason = false
      this.showCommonComment = true
    }
  },
  mounted() {
    this.doInit()
    if (this.showVoidBtn === true) {
      this.initCommonUtilMenu()
    }
  },
  methods: {
    async doInit() {
      this.fetchBranch()
      this.fetchAccount()
      this.fetchFund()
      this.fetchAcctNoSfx()
      this.fetchDepartment()
      this.fetchCurrency()
      this.fetchGstStatus()
      this.fetchBank()
      this.fetchPaymentMethod()
      this.fetchPayerBank()
      this.fetchPolicyType()
      if (this.baseFromMatch) {
        this.skipPrompt = false
      }
      let actionName = 'ACCT_REVIEW'
      if (this.acctMaster.actionName !== undefined && this.acctMaster.actionName !== '') {
        actionName = this.acctMaster.actionName
      }
      await Promise.all([this.performAction(actionName)])
      await this.$store.dispatch('commonCommentsManagementInit')
      this.getRIDetails()
      this.getGLList()
      this.getMatchList()
      this.getRIMatchList()
      this.getCommPVList()
      if (this.acctMaster.rbcTran === 'Yes') {
        this.disableRIPanel = false
      } else {
        this.disableRIPanel = true
      }
      if (
        this.acctMaster.postNow === 'N' ||
        this.acctMaster.createdProgId === 'TreatyHeader' ||
        this.acctMaster.createdProgId === 'MthlyUpdUW' ||
        this.acctMaster.createdProgId === 'MthlyUpdClm'
      ) {
        this.disableGLList = true
      } else {
        this.disableGLList = false
      }
      this.voidReason = this.accounts.voidReason
    },
    doPrev() {
      if (this.baseFromMatch) {
        this.skipPrompt = true
      }
      this.$router.go(-1)
    },
    chkRbcTran() {
      // If acctMaster.rbcTran = True then enable RI section else disable
      if (this.accounts.rbcTran === 'Yes') {
        return false
      } else {
        return true
      }
    },
    doBack() {
      if (this.baseFromMatch) {
        this.skipPrompt = true
      }
      this.$store.commit(INDIC_UNLOCK, false)
      if (this.showVoidBtn === true) {
        this.unlockRecord(this.recKey, 'ACT')
      }
      if ((this.acctMaster.actionName === undefined || this.acctMaster.actionName === '') && (this.acctMaster.transfer === undefined || this.acctMaster.transfer === '')) {
        this.$router.push({ name: 'accounts' }).catch(() => {})
      } else {
        this.$router.go(-1)
      }
    },
    doVoid() {
      this.voiding()
    },
    async voiding() {
      this.submitting = true
      const apiUrl = this.voidMenu.process
      if (apiUrl) {
        try {
          const req = {
            branch: this.acctMaster.branch,
            acctNo: this.acctMaster.acctNo,
            tranType: this.acctMaster.tranType,
            docNo: this.acctMaster.docNo,
            fund: this.acctMaster.fund,
            acctNoSfx: this.acctMaster.suffix,
            voidReason: this.form.voidReason,
            voidMultiAcct: this.voidMultiAcct
          }
          const result = await this.$http.post(apiUrl, req)
          const { data } = result.data
          if (data) {
            this.notify(data.voidAccountTransaction)
            this.doBack()
          } else {
            this.$toast.error('Unexpected server response')
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      } else {
        this.$toast.error('Missing API URL (process void account txn)')
      }
      this.submitting = false
    },
    checkVoidReason() {
      this.resetMessages()
      this.$validator.validateAll('voidReasonForm').then(result => {
        if (result) {
          this.showVoidConfirmation = true
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async checkComment() {
      const apiUrl = this.commentURL.isExistComment
      if (apiUrl) {
        try {
          const expand = {
            commentRefNo: this.commentRefNo
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          const { data } = result.data
          if (data === true) {
            this.showVoidConfirmation = true
          } else {
            this.promptCommentDialog = true
          }
        } catch (err) {
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    closeDialog() {
      this.promptCommentDialog = false
    }
  },
  computed: {
    acctMaster() {
      return this.$store.state.accounts.acctMaster
    },
    showButtons() {
      return this.acctMaster.actionName !== undefined && this.acctMaster.actionName !== '' && this.acctMaster.actionName === 'ACCT_VOID'
    },
    voidMenu() {
      return this.$store.state.specFuncAcct.voidAccountTransaction.menu
    },
    apiURI() {
      return ''
    },
    commentRefNo() {
      return (
        this.acctMaster.acctNo +
        this.acctMaster.docNo +
        this.acctMaster.fund +
        this.acctMaster.suffix +
        this.acctMaster.branch +
        this.acctMaster.tranType
      )
    },
    recKey() {
      return strJoin('|', this.acctMaster.tranType, this.acctMaster.branch, this.acctMaster.acctNo, this.acctMaster.docNo, this.acctMaster.fund, this.acctMaster.suffix)
    },
    commentTranType() {
      return this.acctMaster.tranType
    },
    commentURL() {
      return this.$store.state.commonComments.menu
    },
    fromAcctMaster() {
      return this.$route.params.fromAcctMaster
    },
    queryAcctMaster() {
      return this.$route.params.queryAcctMaster
    },
    voidMultiAcct() {
      return this.$route.params.voidMultiAcct
    },
    baseFromMatch() {
      return this.$store.state.accounts.acctMchObj.baseFromMatch
    },
    baseRecKey() {
      return this.$store.state.accounts.acctMchObj.baseRecKey
    },
    appendCreatedModifiedProgram() {
      let program = this.accounts.createdProgram
      if (this.accounts.modifiedProgram) {
        program = program + ', ' + this.accounts.modifiedProgram
      }
      return program
    },
    filterBranchList() {
      return this.allbranches.filter((list) => {
        return list.value === this.accounts.branch
      })
    },
    filterDepartmentList() {
      return this.departments.filter((list) => {
        return list.value === this.accounts.department
      })
    },
    filterCurrList() {
      return this.currencies.filter((list) => {
        return list.value === this.accounts.currency
      })
    },
    filterFundSuffixList() {
      let fundSuffix = this.funds
        .filter(fund => fund.value === this.accounts.fund)
        .map(fund => fund.label)
      const suffix = this.acctnosuffixes
        .filter(sfx => sfx.value === this.accounts.acctNoSfx)
        .map(sfx => sfx.label)
      if (suffix) {
        fundSuffix = fundSuffix + ', ' + suffix
      }
      return fundSuffix
    },
    filterAccountNoList() {
      return this.accountnos.filter((list) => {
        return list.value === this.accounts.accountNo
      })
    },
    filterGstIOStatusRate() {
      let gstIOStatusRate = this.gstIOOptions
        .filter(io => io.value === this.accounts.inOutGST)
        .map(io => io.label)
      const gststat = this.gstStatuses
        .filter(gst => gst.value === this.accounts.gstStat)
        .map(gst => gst.label)
      return gstIOStatusRate + ', ' + gststat + ', ' + this.accounts.gstRate
    }
  },
  mixins: [routeMixin, MessageMixin, accountsAjaxCalls, accountsViewMixin, promptOnExitMixin, recordLockMixin],
  props: {
    accountData: {
      type: Object,
      default: null
    }
  },
  components: {
    PolicyDetails,
    DocumentDetails,
    BankDetails,
    MatchDetails,
    RIDetails,
    GLList,
    MatchedList,
    CommPVList,
    CommonComments,
    PromptLeave
  }
}
</script>
<style lang="scss">
@import '../../../../assets/scss/accounting.scss';
</style>
